import type { Config } from './Config';

/**
 * An interface model for remote Config
 */
export interface HackleRemoteConfig extends Config {
  get(
    key: string,
    defaultValue: string | number | boolean
  ): Promise<string | number | boolean>;
}

export class EmptyHackleRemoteConfig implements HackleRemoteConfig {
  getSync(
    _key: string,
    defaultValue: string | number | boolean
  ): string | number | boolean {
    return defaultValue;
  }

  get(
    _key: string,
    defaultValue: string | number | boolean
  ): Promise<string | number | boolean> {
    return Promise.resolve(defaultValue);
  }
}
